import { computed, reactive } from 'vue';
import { useQuery } from 'vue-query';
import { UseQueryOptions } from 'react-query/types';

import QUERY_KEYS from '@/constants/queryKeys';
import { balancerFarmSubgraphService } from '@/services/balancer/subgraph/balancer-farm-subgraph.service';
import { UserFlakeInfos } from '@/services/balancer/subgraph/types';
import useNetwork from '../useNetwork';
import useWeb3 from '@/services/web3/useWeb3';

type UserFlakeInfosResponse = UserFlakeInfos[];

export default function useUserFlakeInfosQuery(
  options: UseQueryOptions<UserFlakeInfosResponse> = {}
) {
  // COMPOSABLES
  const { networkId } = useNetwork();
  const { account, isWalletReady } = useWeb3();

  /**
   * COMPUTED
   */
  const enabled = computed(() => isWalletReady.value && account.value != null);

  // DATA
  const queryKey = reactive(QUERY_KEYS.FarmPools.UserFlakeInfos(networkId));

  // METHODS
  const queryFn = async () => {
    const userLeaveRequests = await balancerFarmSubgraphService.userFlakeInfos.get(
      {
        where: {
          user: account.value
        }
      }
    );

    return userLeaveRequests;
  };

  const queryOptions = reactive({
    enabled,
    ...options
  });

  return useQuery<UserFlakeInfosResponse>(queryKey, queryFn, queryOptions);
}
